
import { 
    REQUEST_EXPERTS,
    RESPONSE_EXPERTS,
    REQUEST_EXPERTS_FAILURE
} from '../actions/types';

const initialState = {
   isFetching: false,
   experts: {},
   error: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_EXPERTS:
            return {
                ...state,
               isFetching: true
            }
            break;   
        
        case RESPONSE_EXPERTS:
            return {
                ...state,
                isFetching: false,
                experts: action.payload.experts || {}
            }
        
        case REQUEST_EXPERTS_FAILURE:
            return {
                ...state,
                isFetching:false,
                error: true
            }
      
        default:
            return state;
            break;
    }
}